import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';

export default function NotFound() {
  useEffect(() => {
    document.title = "404 - Seite nicht gefunden | reputrust.ai";
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-600 selection:bg-tron-primary/30 selection:text-[#0F172A] flex flex-col">
      <Header />

      <div className="flex-grow flex items-center justify-center relative overflow-hidden pt-20">
        {/* Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-tron-primary/10 rounded-full blur-[120px] animate-pulse"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 text-center px-6">
          <div className="bg-white p-12 rounded-2xl shadow-lg border border-slate-200 dashed max-w-lg mx-auto">
            <h1 className="text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#10B981] to-[#1E3A8A] mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              404
            </h1>
            <h2 className="text-2xl md:text-3xl font-bold text-[#0F172A] mb-6" style={{ fontFamily: 'Inter Tight, sans-serif' }}>
              Seite nicht gefunden
            </h2>
            <p className="text-slate-600 mb-10 text-lg" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              Die angeforderte Seite konnte im System nicht lokalisiert werden. Möglicherweise wurde sie verschoben oder gelöscht.
            </p>

            <Link
              to="/"
              className="inline-flex items-center justify-center px-8 py-3 bg-white border border-slate-200 text-slate-600 rounded hover:bg-slate-50 hover:text-[#0F172A] hover:border-slate-300 transition-all duration-300 hover:shadow-md group"
            >
              <span className="font-medium">Zurück zur Startseite</span>
              <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}